import clsx from 'clsx';
import type * as React from 'react';

import type { MarkProps } from '@gitbook/slate-react';
import { Code } from '@gitbook/spine-react';

export function MarkCode(props: MarkProps): React.ReactElement {
    const { children, attributes } = props;
    // if the string is short we'll try to preserve it without line breaks
    // however, we don't want the inline code to overflow the editor so only do this for short strings
    const isShortString = typeof children === 'string' && children.length < 50;
    return (
        <Code
            className={clsx(isShortString ? 'whitespace-nowrap' : '[box-decoration-break:clone]')}
            {...attributes}
        >
            {children}
        </Code>
    );
}
